import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Briefcase, Building2, User, Sparkles, LogIn } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/**
 * MobileBottomNav - Fixed bottom navigation bar for mobile devices
 * Shows: Offres, Offre+, Entreprises, Profil (or Login)
 */
const MobileBottomNav = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const { user } = useAuth();

    const navItems = [
        {
            path: '/offres_vie',
            label: 'Offres',
            icon: Briefcase,
            tour: 'tour-nav-offres-mobile',
            isActive: currentPath === '/offres_vie' || currentPath.startsWith('/offres_vie')
        },
        {
            path: '/offres-plus',
            label: 'Offre+',
            icon: Sparkles,
            tour: 'tour-nav-offresplus-mobile',
            isActive: currentPath === '/offres-plus'
        },
        {
            path: '/les-entreprises',
            label: 'Entreprises',
            icon: Building2,
            tour: 'tour-nav-entreprises-mobile',
            isActive: currentPath === '/les-entreprises'
        },
        // Conditional Item: Profile or Login
        user ? {
            path: '/profil',
            label: 'Profil',
            icon: User,
            tour: 'tour-nav-profil-mobile',
            isActive: currentPath === '/profil' || currentPath.startsWith('/profil')
        } : {
            path: '/login',
            label: 'Se connecter',
            icon: LogIn,
            isActive: currentPath === '/login'
        }
    ];

    return (
        <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-50 md:hidden safe-area-pb">
            <div className="flex items-center justify-around h-16">
                {navItems.map(({ path, label, icon: Icon, isActive, tour }) => (
                    <Link
                        key={path}
                        to={path}
                        data-tour={tour}
                        className={`flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors ${isActive
                            ? 'text-blue-600'
                            : 'text-slate-400 hover:text-slate-600'
                            }`}
                    >
                        <Icon size={22} strokeWidth={isActive ? 2.5 : 2} />
                        <span className={`text-[11px] ${isActive ? 'font-bold' : 'font-medium'}`}>
                            {label}
                        </span>
                    </Link>
                ))}
            </div>
        </nav>
    );
};

export default MobileBottomNav;
